import "babel-polyfill";
import Vue from 'vue'
import OrderRegisterForm from '../src/components/order/OrderRegisterForm'

import moment from 'vue-moment'
Vue.use(moment)

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter,
  {
    symbol : '円',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: true
  })

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('order-register-form-container');
  new Vue({
    el,
    render: h => h(OrderRegisterForm, { props: JSON.parse(el.dataset.props) })
  });
});
